// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__-oysB","vLegacy":"SelectSecondary_vLegacy__fUVmS","error":"SelectSecondary_error__3r3ia","disabled":"SelectSecondary_disabled__2km45"};